export const osaMailtoUrl = "#";

export const toastMailtoUrl = "#";
